import { useState, useEffect, useContext } from 'react';
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import { Text, Card, CardPreview, CardHeader, Checkbox } from '@fluentui/react-components';
import { ControlPanelNavigation } from './control-panel-navigation.js';
import { API_PATH } from '../Constants.ts';

import LowPolyOffice from './resources/LowPolyOffice.png';
import RealisticOffice from './resources/RealisticOffice.png';
import ClinicRoom from './resources/ClinicRoom.png';
import LowPolyForest from './resources/LowPolyForest.png';
import TinyLowPolyForest from './resources/TinyLowPolyForest.png';
import StroopTest from './resources/StroopTest.png';
import HeartRateTraining from './resources/HeartRateTraining.png';
import EmptyScenario from './resources/EmptyScenario.png';
import JapanGarden from './resources/JapanGarden.png';
import Oasis from './resources/Oasis.png';
import Terminal from './resources/Terminal.png';

import { fetchConfig } from '../utils/fetchScenarioConfiguration.ts';
const config = await fetchConfig();

const scenarioImages = {
    LowPolyOffice,
    RealisticOffice,
    ClinicRoom,
    LowPolyForest,
    TinyLowPolyForest,
    StroopTest,
    HeartRateTraining,
    EmptyScenario,
    JapanGarden,
    Oasis,
    Terminal,
};

const scenarios = config.scenarios.map(scenario => {
  const imageTitle = scenario.name.split(' ').join(''); // convert scenario.name (e.g. 'Low Poly Forest') to 'LowPolyForest'
  scenario.url = scenarioImages[imageTitle];
  scenario.alt = scenario.name;
  scenario.title = scenario.name;
  return scenario;
});

export const AllowedScenariosSelection = () => {
  const [processing, setProcessing] = useState(false);
  const { selectedPatientId } = useContext(SelectedPatientContext);
  const [selectedScenarios, setSelectedScenarios] = useState({});

  const submitSelectedScenario = (scenario_id) => {
      setProcessing(true);

      let patient_id = selectedPatientId;
      if (!Number.isInteger(patient_id)) {
          console.error('submitSelectedScenario(): No patient selected. Cannot set scenario permissions.');
          alert('No patient selected. Please select a patient to continue.');
          setProcessing(false);
          return;
      }

      if (!Number.isInteger(scenario_id)) {
          console.error('Selected scenario ID is not a valid integer.');
          setProcessing(false);
          return;
      }

      const checkboxStateBefore = selectedScenarios[scenario_id];
      console.log(`Selected scenario ${scenario_id} was ${checkboxStateBefore ? 'selected' : 'deselected'}. Switching to opposite value after mouse click.`);    
      setSelectedScenarios(prev => ({ ...prev, [scenario_id]: !checkboxStateBefore }));
      
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' },
          body: JSON.stringify({scenario_id: scenario_id, patient_id: patient_id, selected: !checkboxStateBefore})
      };

      console.log(`sending POST request with body: `, requestOptions.body);

      fetch(API_PATH.SET_ASSIGNABLE_SCENARIOS, requestOptions)
      .then(async response => {
          const data = await response.text();
          console.log(`Best effort attempt to set scenario ${scenario_id} as ${!checkboxStateBefore ? 'permitted' : 'forbidden'} for patient ${patient_id}. Probably successfull, but cannot confirm.`);
          console.log('Response (empty response is normal): ', data); // There is no response, by design. Sending a respose requires significant refactoring at backend.
          setProcessing(false);
      })
      .catch(error => {
        console.error(`Submitting selected/deselected scenario failed with error: ${error}`);
        alert("An error occurred while submitting selected/deselected scenario. Please reload the page to continue.");
      });
    };

    useEffect(() => {
      let patient_id = selectedPatientId;
      if (!Number.isInteger(patient_id)) {
        console.error('useEffect[]: No patient selected. Cannot set scenario permissions.');
        alert('No patient selected. Please select a patient to continue.');
        return;
      }
      console.log(`Scenarios: selected patient id: ${patient_id}`);
    }, [selectedPatientId]);

    useEffect(() => {
      console.log(`Updated selectedScenarios: ${JSON.stringify(selectedScenarios)}`);
    }, [selectedScenarios]);

    const fetchScenarioStateForPatient = () => {
      setProcessing(true);

      let patient_id = selectedPatientId;
      if (!Number.isInteger(patient_id)) {
          console.error('useEffect[selectedPatientId]: No patient selected. Cannot set scenario permissions.');
          setProcessing(false);
          return;
      }

      fetch(API_PATH.SET_ASSIGNABLE_SCENARIOS + `?query=(patient_id==${encodeURIComponent(patient_id)})&columns[]=scenario_id`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setSelectedScenarios(prev => Object.fromEntries(Object.keys(prev).map(key => [key, false])));
        data.forEach(value => {
          console.log(`Allowed scenario for current patient: ${value.scenario_id}`);
          setSelectedScenarios(prev => ({ ...prev, [value.scenario_id]: true }));
        });
      })
      .catch(error => {
        console.error(error);
        alert("An error occurred while reading scenarios state (selected/deselected) for current patient. Please reload the page to continue.");
        return;
      });

      setProcessing(false);
    }

    useEffect(() => {
      fetchScenarioStateForPatient();
    }, [selectedPatientId]);

  return (
    <div className='control-panel-layout'>
        <aside className="sidenav">
          <ControlPanelNavigation />
        </aside>
        <div className={`${processing ? 'faded-content' : ''}`} style={{ display: 'flex', flexWrap: 'wrap' }}>
          {scenarios.map((scenario, index) => (
            <Card
              key={index}
              onClick={() => submitSelectedScenario(scenario.id)}
              floatingAction={
                <Checkbox
                  onChange={() => submitSelectedScenario(scenario.id)}
                  checked={!!selectedScenarios[scenario.id]}
                  style={{ backgroundColor: 'white' }}
                />
              }
              selected={!!selectedScenarios[scenario.id]}
              >

              <CardPreview>
                <img src={scenario.url} alt={scenario.alt} style={{ width: '384px', height: '216px' }} />
              </CardPreview>
              <CardHeader
                header={<Text weight="semibold">{scenario.title}</Text>}
              />
            </Card>
          ))}
      </div>
    </div>
  );
};